import React from 'react'
import {
  Row,
  Typography,
  Form,
  Select,
  Input,
  Col,
  Button,
} from "antd";
import {
  PlusOutlined,
} from "@ant-design/icons";
import TextArea from 'antd/es/input/TextArea';

const { Text, Title } = Typography

const MessageForm = (props) => {
  return (
    <Form
      layout="vertical"
      onFinish={props.onFinish}
      form={props.form}
      initialValues={props.initialValues}
      style={{ margin: 30 }}
    >
      <Row
        style={{ justifyContent: "space-between" }}
        gutter={{
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32,
        }}
      >

        <Form.Item
          label={<Text strong>Campaign Message</Text>}
          name={"campaignMessage"}
          rules={[{ required: true, message: "Required Field" }]}
        >
          <TextArea
            style={{ width: "45vh", height: "15vh" }}
            disabled={props.disabled}
          />
        </Form.Item>
      </Row>

      <Row>
        <Title level={3}>Available Template Parameters</Title>
      </Row>
    </Form>

  )
}

export default MessageForm